import { createSlice } from "@reduxjs/toolkit";

interface SerializableRequest {
  args: {
    url: string;
    method?: string;
    body?: any;
    params?: any;
  };
  extraOptions?: {
    offlineSkip?: boolean;
  };
}

interface AuthModalState {
  isOpen: boolean;
  pendingRequests: SerializableRequest[];
  lastLoginTimestamp: number | null;
  sessionWarningShown: boolean;
}

const initialState: AuthModalState = {
  isOpen: false,
  pendingRequests: [],
  lastLoginTimestamp: null,
  sessionWarningShown: false,
};

export const authModalSlice = createSlice({
  name: "authModal",
  initialState,
  reducers: {
    showAuthModal: (state) => {
      state.isOpen = true;
      state.sessionWarningShown = true;
    },
    hideAuthModal: (state) => {
      state.isOpen = false;
    },
    recordSuccessfulLogin: (state) => {
      state.lastLoginTimestamp = Date.now();
      state.sessionWarningShown = false;
      state.isOpen = false;
    },
    resetSessionState: (state) => {
      state.lastLoginTimestamp = null;
      state.sessionWarningShown = false;
      state.isOpen = false;
    },
  },
});

export const { showAuthModal, hideAuthModal, recordSuccessfulLogin, resetSessionState } = authModalSlice.actions;
export default authModalSlice.reducer;
